<template>
  <div>

    <base-header class="pb-6 bg-light">

      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 d-inline-block mb-0 text-dark">Home</h6>
        </b-col>
        <b-col cols="5" lg="6" class="text-right">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>

    <b-row>

      <b-col>

        <b-card>
          <b-card-body>
            <p align="center">
              <img v-bind:src="pageLogo" :style="logoStyle" class="navbar-brand-img"><br>
            </p>
            <p>
              Welcome to the Provisioning Portal. Please click on the navigation at the left for access to your
              products.
            </p>
            <p>
              Requirements for portal use:
              <ul>
                <li>Users must be registered independently.</li>
                <li>Provisioning must be completed before navigating to a new page.</li>
                <li>All portal usage is audited and will be used to identify support questions.</li>
                <li>Support issues can be raised using the blue <b>HELP</b> tab on the side of the portal.</li>
              </ul>
            </p>
          </b-card-body>
        </b-card>

      </b-col>
    </b-row>

    </base-header>

  </div>
</template>
<script>
import RouteBreadCrumb from '../../../components/Breadcrumb/RouteBreadcrumb';
import configDirective from "../../../common/directive/config-directive";

export default {
  components: {
    RouteBreadCrumb,
  },
  data() {
    return {
      pageTitle: '',
      pageLogo: '',
      logoStyle: '',
    };
  },
  mounted() {
    document.title = process.env.VUE_APP_CLIENT.toString().toUpperCase()+' Portal'
    this.pageLogo = '/img/brand/'+process.env.VUE_APP_CLIENT.toString() +'.png';
    let width = `137px`;
    let height = `96px`;
    this.logoStyle = `width: ${width}; `;
  }

};

</script>
